import {COMPANY_KEYS} from "@/api/companyApi";
import Modal from "@/components/Common/Modal";
import {useUserPermission} from "@/hooks/useUserHooks";
import {client} from "@/httpClient";
import ImagePlaceholder from "@/images/navbar_logged_out_profile_icon.svg";
import {isRequestMoreResourcesModalOpenAtom} from "@/store/jotaiAtoms";
import useUserStore from "@/store/user";
import {useMutation} from "@tanstack/react-query";
import {useAtom} from "jotai";
import {RESET} from "jotai/utils";
import {FC} from "react";
import {useTranslation} from "react-i18next";

const RequestMoreModal: FC = () => {
  const {t} = useTranslation("payments");
  const [requestModal, setRequestModal] = useAtom(isRequestMoreResourcesModalOpenAtom);
  const user = useUserStore(state => state.user);
  const userPermission = useUserPermission();
  const {mutateAsync, isPending} = useMutation({
    mutationKey: COMPANY_KEYS.mCompanyAdditionalLimitRequest(user.sub_brands?.at(0)?.company.id!),
    mutationFn: () =>
      client.post(COMPANY_KEYS.mCompanyAdditionalLimitRequest(user.sub_brands?.at(0)?.company.id!)[0], {
        limit_type: requestModal.type.toUpperCase(),
      }),
  });

  return (
    <Modal
      onClose={() => setRequestModal(RESET)}
      shouldCloseOnConfirm
      onConfirm={async () => await mutateAsync()}
      isLoading={isPending}
      backgroundClassName="flex max-w-[800px]"
      modalTitle={t("request_more", {type: requestModal.type})}>
      <div className="border-neutral-grey-lightest flex flex-row items-center justify-between gap-2 rounded-full border-2 p-1">
        <div className="flex items-center gap-1">
          <div className="border-neutral-grey-light-dark size-6 shrink-0 rounded-full border">
            <img src={user.profile_picture ?? ImagePlaceholder} className="h-full w-full rounded-full object-fill" />
          </div>
          <span className="bg-linear-(--primary-dark-gradient) bg-clip-text font-semibold text-transparent">
            {user.first_name}
          </span>
        </div>
        <span className="text-neutral-black text-xs text-nowrap">
          {t(
            `multi_account:${(userPermission === "REFLUENCED_COMPANY_ADMIN" ? "ADMIN" : userPermission).toLowerCase()}_permissions`,
          )}
        </span>
      </div>
      <div className="text-sm">{t("request_more_description", {type: requestModal.type})}</div>
    </Modal>
  );
};

export default RequestMoreModal;
